<template>
  <div>
    <el-dialog :title="$t('user72')" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="dialog.edit" class="info-dialog">
      <el-form :model="formData" ref="formData" :rules="rules" class="form-data">

        <div class="form-item">
          <div class="form-item-label">
            <I18Lang id="user73" defaultText="原用户名" />
          </div>
          <div class="form-item-value">{{ userInfo.username }}</div>
        </div>

        <el-form-item prop="username">
          <el-input v-model="formData.username" :placeholder="$t('user74')"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div class="btn kg-btn2" type="primary" @click="submitForm('formData')">
          <I18Lang id="user84" defaultText="提交" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import http from '@utils/http'
import i18n from '@utils/i18n'
export default {
  name: 'record',
  data () {
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(i18n.t('public8'))) // '请输入姓名'
      } else {
        http.post('/api/user/checkIsExist', { username: value }).then(result => {
          if (result.is_exist) {
            callback(new Error(i18n.t('public9'))) // 用户名已经存在，请填写其他用户名
            return false
          } else {
            callback()
          }
        })
      }
    }

    return {
      dialog: {
        edit: false
      },
      formData: {
        username: ''
      },
      rules: {
        username: [
          { required: true, validator: validateName, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    showDialog () { // 修改类型
      this.dialog.edit = true
    },
    submitForm (formName) {
      this.isSubmitLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData()
        } else {
          this.isSubmitLoading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    submitData () {
      this.$http.post('/api/user/editUsername', this.formData).then(result => {
        this.dialog.edit = false
        this.$emit('onUpdata')
        this.$message.success(this.$t('public16'))
      }).catch(() => {
        this.isSubmitLoading = false
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  },
  computed: {
    ...mapState(['userInfo'])
  }
}
</script>
<style scoped lang="scss">
::v-deep .info-dialog {
  .el-dialog {
    width: 606px !important;
    min-height: 400px;
    height: 400px;
    background: url("../../../../assets/img/user/short-bg.png") no-repeat center / 100% 100%;

    .el-dialog__header {
      .el-dialog__title {
        padding-top: 5px;
      }

      .el-dialog__headerbtn {
        margin-top: 8px;
      }
    }

    .form-item {
      margin-bottom: 35px;

      .form-item-label {
        font-size: 16px;
        font-weight: 400;
        color: #01B2F5;
        margin-bottom: 10px;
      }

      .form-item-value {
        font-size: 16px;
        font-family: Arial;
        font-weight: 400;
        color: rgb(#FFFFFF, 0.6);
      }
    }
  }
}
</style>
